import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"

import {SelectQuestion} from "./SelectQuestion"
import {MultiQuestion} from "./MultiQuestion"

import {TextToHTML} from "@indebted/components/TextToHTML"
import {Page} from "@indebted/components/Page"

function Question({question, answers, onAnswer}) {
	const components = {
		select: SelectQuestion,
		"multi-question": MultiQuestion,
	}
	const Component = components[question.Type]
	return (
		<Page padded>
			<Grid container direction="column" alignItems="stretch" justifyContent="center" spacing={5} padding={0}>
				<Grid>
					<Typography variant="h6">{question.Statement}</Typography>
				</Grid>

				<Grid>
					<TextToHTML variant="body2" text={question.Details} component="div" />
				</Grid>
				<Grid>
					<Component question={question} answers={answers} onAnswer={onAnswer} />
				</Grid>
			</Grid>
		</Page>
	)
}

export {Question}
